import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addSchoolAdminThunk, removeSchoolAdminThunk } from "../../../shared/store/redux/schoolManager-actions";
import { addSchoolManager, removeSchoolManager } from "../../../shared/store/redux/schoolManager-slice";
import RoleHoldersList from "./roleHoldersList/RoleHoldersList";
import FixedPermissionsList from "./fixedPermissionsList/FixedPermissionsList";
import AddPermissionPopup from "./addPermissionPopup/AddPermissionPopup";
import Button from "../../../shared/components/ui/buttons/Button";
import Icon from "../../../shared/components/ui/icons/Icon";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import schoolAdminLevelEnum from "../../../shared/enums/schoolAdminLevelEnum";
import classes from "./RolePermissionsPage.module.css";

const RolePermissionsPage = () => {
    const texts = useSelector((state) => state.translate.texts);
    const schoolId = useSelector((state) => state.auth.userDetails?.defaultSchool?.id);
    const schoolName = useSelector((state) => state.auth.userDetails?.defaultSchool?.name);
    const [showPopup, setShowPopup] = useState(false);
    const dispatch = useDispatch();

    const handleAdd = async (participant) => {
        const success = await dispatch(addSchoolAdminThunk(schoolId, schoolName, participant.id, schoolAdminLevelEnum.Edit));
        if (success)
            dispatch(addSchoolManager({ id: participant.id, permissionLevelId: schoolAdminLevelEnum.Edit }));
    };

    const handleRemove = async (participant) => {
        const success = await dispatch(removeSchoolAdminThunk(schoolId, participant.id));
        if (success)
            dispatch(removeSchoolManager(participant.id));
    };

    return (
        <div className={classes.Page}>
            <div className={classes.Header}>
                <div className={classes.TitleBlock}>
                    <h1 className={classes.Title}>{texts.roleHolders}</h1>
                </div>
                <Button className={classes.AddBtn} onClick={() => setShowPopup(true)} accessibilityDescription={texts.addManagementPermission}>
                    <span>{texts.addManagementPermission}</span>
                    <Icon name={iconsList.addCircleButton} size="20px" color="white" />
                </Button>
            </div>
            <hr className={classes.Divider} />
            <FixedPermissionsList />
            <p className={classes.siteManagementPermissionsSubtitle}>{texts.siteManagementPermissionsSubtitle}</p>
            <RoleHoldersList onRemove={handleRemove} />
            {showPopup && (
                <AddPermissionPopup
                    onClose={() => setShowPopup(false)}
                    onAdd={handleAdd}
                />
            )}
        </div>
    );
};

export default RolePermissionsPage;
